export enum RiskAssessmentType {
  AML_RISK = 'AML_RISK',
  BANK_READER_RISK = 'BANK_READER_RISK',
}
